import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { getLayerImage } from '@/redux/layers/layers.thunks';
import updateElement from '@/components/Map/MapViewer/utils/mapElementsRendering/layer/utils/updateElement';
import { MapInstance } from '@/types/map';
import drawElementOnLayer from '@/components/Map/MapViewer/utils/mapElementsRendering/layer/utils/drawElementOnLayer';
import { layerDeleteImage } from '@/redux/layers/layers.slice';
import removeElementFromLayer from '@/components/Map/MapViewer/utils/mapElementsRendering/layer/utils/removeElementFromLayer';
import { getLayerImageAdapterId } from '@/utils/layer/LayerImageAdapter';

export default async function processLayerImage({
  data,
  mapInstance,
}: {
  data: WebSocketEntityUpdateInterface;
  mapInstance: MapInstance;
}): Promise<void> {
  const { dispatch } = store;
  if (
    data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED ||
    data.type === ENTITY_OPERATION_TYPES.ENTITY_UPDATED
  ) {
    const resultImage = await dispatch(
      getLayerImage({
        modelId: data.mapId,
        layerId: data.layerId,
        imageId: data.entityId,
      }),
    ).unwrap();
    if (!resultImage) {
      return;
    }
    if (data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED) {
      drawElementOnLayer({
        mapInstance,
        activeLayer: data.layerId,
        object: resultImage,
        drawFunctionKey: 'drawImage',
      });
    } else {
      updateElement(mapInstance, data.layerId, resultImage);
    }
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_DELETED) {
    dispatch(
      layerDeleteImage({
        modelId: data.mapId,
        layerId: data.layerId,
        imageId: data.entityId,
      }),
    );
    removeElementFromLayer({
      mapInstance,
      layerId: data.layerId,
      featureId: getLayerImageAdapterId(data.entityId),
    });
  }
}
